<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header">
        <h2 class="panel-title">
          {{ $t('admin.panel') }}
        </h2>
      </header>
      <div class="config-panel panel-scroll">
        <div
          class="row space-between"
        >
          <div>
            <div class="config-label">
              {{ $t('manage.services') }}
            </div>
            <div class="config-description">
              {{ $t('manage.services.description') }}
            </div>
          </div>
          <router-link :to="{name: 'ListServicesPage'}">
            <div
              class="next-step"
            />
          </router-link>
        </div>
        <div
          class="row space-between"
        >
          <div>
            <div class="config-label">
              {{ $t('manage.admins') }}
            </div>
            <div class="config-description">
              {{ $t('manage.admins.description') }}
            </div>
          </div>
          <router-link :to="{name: 'ListAdminsPage'}">
            <div
              class="next-step"
            />
          </router-link>
        </div>
        <div class="row space-between">
          <div>
            <div class="config-label">
              {{ $t('manage.devices') }}
            </div>
            <div class="config-description">
              {{ $t('manage.devices.description') }}
            </div>
          </div>
          <router-link :to="{name: 'ListDevicesPage', query: { status: 'all' }}">
            <div
              class="next-step"
            />
          </router-link>
        </div>
        <div class="row space-between">
          <div>
            <div class="config-label">
              {{ $t('manage.notifiers') }}
            </div>
            <div class="config-description">
              {{ $t('manage.notifiers.description') }}
            </div>
          </div>
          <router-link :to="{name: 'ListNotifiersPage'}">
            <div
              class="next-step"
            />
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapState([
      'loggedUser'
    ])
  }
}
</script>
